<template>
  <a-popover :class="{ 'popover-disabled': !activeQueues.length }" trigger="hover" overlayClassName="queue-popover-overlay">
    <template #title>
      <div class="queue-popover-title">Colas ({{ activeQueues.length }})</div>
    </template>
    <template #content>
      <div class="queue-popover-content">
        <div v-for="queue in activeQueues.slice(0, 4)" :key="queue.id" class="queue-item">
          <div class="queue-item-info">
            <span class="queue-item-name" :title="queue.name">{{ queue.name }}</span>
            <span class="queue-item-campaign">Campaña: {{ queue.portfolio_name }}</span>
          </div>
          <a-tag color="green">
            Activo
          </a-tag>
        </div>
        
        <div v-if="activeQueues.length > 4" class="queue-list-more">
          <a-button type="link" class="queue-more-btn" @click="$emit('open-detail', userName, activeQueues)">
            <EyeOutlined /> Ver {{ activeQueues.length - 4 }} más
          </a-button>
        </div>
      </div>
    </template>

    <span>
      <InfoCircleOutlined style="margin-right: 8px" />
      <span v-if="activeQueues.length">
        {{ activeQueues.length }} {{ activeQueues.length === 1 ? "cola" : "colas" }}
      </span>

      <span v-else>Sin colas</span>
    </span>
  </a-popover>
</template>

<script>
import { defineComponent } from 'vue';
import { EyeOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  name: 'SupervisionQueuePopover',
  components: {
    EyeOutlined,
    InfoCircleOutlined,
  },
  props: {
    queues: {
      type: Array,
      default: () => [],
    },
    userName: {
      type: String,
      default: '',
    },
  },
  emits: ['open-detail'],
  computed: {
    activeQueues() {
      return this.queues?.filter(q => q.status === 1) || [];
    }
  }
});
</script>

<style lang="sass" scoped>
.popover-disabled
  pointer-events: none
  color: $gray-7

.queue-popover-title
  font-weight: 600
  color: #434343
  padding-bottom: 4px
  border-bottom: 1px solid #f0f0f0
  margin-bottom: 8px

.queue-popover-content
  display: flex
  flex-direction: column
  gap: 12px
  min-width: 280px
  max-width: 320px

.queue-item
  display: flex
  justify-content: space-between
  align-items: center

.queue-item-info
  display: flex
  flex-direction: column
  overflow: hidden
  padding-right: 12px
  flex: 1
  min-width: 0

.queue-item-name
  font-size: 14px
  color: #434343
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.queue-item-campaign
  font-size: 12px
  color: #8c8c8c
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.queue-list-more
  text-align: center
  border-top: 1px solid #f0f0f0
  padding-top: 8px
  margin-top: -4px

.queue-more-btn
  padding: 0
  display: inline-flex
  align-items: center
  gap: 4px
</style>
